import { IntegrationRequestModal } from 'features/Integrations/modals';
import {
  ManageSmartSpotModal,
  MarkClassAsFullConfirmationModal,
  MarkClassAsNotFullConfirmationModal,
  NetworkCapRecurrenceModal,
  PremiumOnlyModal,
  TurnOnSmartSpotConfirmationModal,
} from 'features/YieldManagement/modals';
import { ReservationFeedbackModalV2 } from 'features/ReservationFeedback/modals';
import {
  AddClassModal,
  AddInstructorModal as AddScheduleInstructorModal,
  DeleteScheduleModal,
  PublishScheduleDraftModal,
  ScheduleConflictsModal,
  ConfirmPublishModal,
  PublishSuccessModal,
  AddClasstivityClassModal,
} from 'features/Schedules/modals';
import { ReportReviewConfirmationModal, RemoveStudioResponseConfirmationModal } from 'features/Ratings/modals';
import {
  AdditionalPhotoDeleteConfirmModal,
  BulkFCFModeConfirmModal,
  CreateDisabledTimeWindowConfirmModal,
  DeleteDisabledTimeWindowConfirmModal,
  SuccessDisabledTimeWindowModal,
} from 'features/VenuePage/modals';
import ImageCarousel from 'components/ImageCarousel';
import CancelScheduleModal from 'components/CancelScheduleModal';
import {
  AddStaffAccountModal,
  EditStaffAccountModal,
  DeleteStaffAccountConfirmationModal,
} from 'features/Account/StaffAccounts/modals';
import {
  AppointmentAddVenueBlockModal,
  DeleteBlockOffTimeModal,
  ConfirmStaffBlockModal,
  AlternativeTimeConfirmationModal,
  AlternativeTimeLoadingModal,
} from 'features/Appointments/modals';
import {
  DeleteServiceModal,
  ResetScheduleIncrementsModal,
  UpdateIncrementsConfirmationModal,
} from 'features/ManageServices/Services';
import ServiceInReviewModal from 'features/ManageServices/Services/ServiceInReviewModal';
import { DeletePractitionerModal } from 'features/ManageServices/Practitioners';
import { DeleteResourceModal } from 'features/ManageServices/Resources';
import { DeleteInstructorModal } from 'features/Instructors/DeleteInstructorModal';
import EmailModal from 'components/EmailModal';
import EnableClassConfirmationModal from 'features/ClassDetail/ClassDetailTable/EnableClassConfirmationModal';
import SkuCancelConfirmModal from 'features/Sku/Orders/SkuCancelConfirmModalContainer';
import SkuAvailabilityModal from 'features/Sku/Orders/SkuAvailabilityModal';
import SkuMissedPickupModal from 'features/Sku/Orders/SkuMissedPickupModal';
import SkuOutOfStockConfirmModal from 'features/Sku/Orders/SkuOutOfStockConfirmModal';
import DisableServiceConfirmationModal from 'features/ManageServices/ClassList/DisableServiceConfirmationModal';
import EnableServicePricingModal from 'features/ManageServices/ClassList/EnableServicePricingModal';
import CropperModal from 'features/VenuePage/VenuePhotos/CropperModal';
import {
  PlatformNotSupportedModal,
  NotListedPlatformModal,
  ResetCalendarSyncFlowModal,
  ChangeGoogleAccountModal,
  IcalExportModal,
  DeleteCalendarConfirmationModal,
} from 'features/Appointments/CalendarLinks/Components/Modals';
import EnableFreeClassModal from 'features/ClassDetail/EnableFreeClassModal';
import CampaignsModal from 'features/Campaigns/CampaignsModal';
import NoEquipmentOrPractitionerModal from 'features/ManageServices/Services/ServiceForm/NoEquipmentOrPractitionerModal';
import PayoutAgreementDialog from 'features/ManageServices/Services/ServiceForm/PayoutAgreementDialog';
import PriceSubmitErrorModal from 'features/ManageServices/Services/ServiceForm/PriceSubmitErrorModal';
import { CampaignSaveModal, CampaignEndModal } from 'features/Campaigns/modals';
import CalSyncTutorialModal from 'features/Appointments/CalendarLinks/CalSyncTutorialModal/CalSyncTutorialModalContainer';
import VenueClosedConfirmationModal from 'features/Items/components/VenueClosedConfirmationModal';
import AddMenuModal, { EditMenuModal } from 'features/Sku/Items/components/AddMenuFlyout';
import SkuVenueClosedConfirmationModal from 'features/Sku/Items/components/SkuVenueClosedConfirmationModal';
import ItemAvailabilityModal from 'features/Items/components/ItemAvailabilityModal';
import ItemInReviewModal from 'features/Items/components/ItemInReviewModal';
import ItemSubmitErrorModal from 'features/Items/components/ItemSubmitErrorModal';
import SkuItemInReviewModal from 'features/Sku/Items/components/SkuItemInReviewModal';
import SkuRemoveItemFromCategoryModal from 'features/Sku/Items/components/SkuRemoveItemFromCategoryModal';
import ReservationCancellationModal from 'features/YieldManagement/ReservationCancellationModal';
import { SmartSpotONConfirmModal } from 'features/SmartTools/Components';
import AttendanceInquiryModal from 'features/Home/AttendanceInquiry/AttendanceInquiryModal';
import MFASetupModal, { MFARecoveryCodesModal } from 'features/Account/Settings/MFASetupModal';
import MissingDataFeedbackModal from 'features/Stats/TabClassInsights/MissingDataFeedbackModal';
import ConfirmationModal from 'components/ConfirmationModal';
import AddCategoryModal from 'features/Sku/Items/components/AddCategoryModal';
import DeleteCategoryModal from 'features/Sku/Items/components/DeleteCategoryModal';
import DeleteModifierGroupModal from 'features/Sku/Modifiers/components/DeleteModifierGroupModal';
import DisableCategoryModal from 'features/Sku/Items/components/DisableCategoryModal';
import DuplicateCategoryModal from 'features/Sku/Items/components/DuplicateCategoryModal';
import EditCategoryModal from 'features/Sku/Items/components/EditCategoryModal';
import SmartRateHowItWorksModal from 'features/SmartRate/HowSmartRateWorks/SmartRateHowItWorksModal';
import { EditSharedGroupModal, HiddenGroupModal } from 'features/Sku/Modifiers/components';
import ReviewMenuItemsModal from 'features/Sku/Modifiers/components/ReviewMenuItemsModal';

const MODAL_MAP = {
  AddCategoryModal,
  AddClassModal,
  AddClasstivityClassModal,
  AddMenuModal,
  AddScheduleInstructorModal,
  AddStaffAccountModal,
  AdditionalPhotoDeleteConfirmModal,
  AlternativeTimeConfirmationModal,
  AlternativeTimeLoadingModal,
  AppointmentAddVenueBlockModal,
  AttendanceInquiryModal,
  BulkFCFModeConfirmModal,
  CalSyncTutorialModal,
  CampaignEndModal,
  CampaignSaveModal,
  CampaignsModal,
  CancelScheduleModal,
  ChangeGoogleAccountModal,
  ConfirmationModal,
  ConfirmPublishModal,
  ConfirmStaffBlockModal,
  CreateDisabledTimeWindowConfirmModal,
  CropperModal,
  DeleteBlockOffTimeModal,
  DeleteCalendarConfirmationModal,
  DeleteCategoryModal,
  DeleteDisabledTimeWindowConfirmModal,
  DeleteInstructorModal,
  DeleteModifierGroupModal,
  DeletePractitionerModal,
  DeleteResourceModal,
  DeleteScheduleModal,
  DeleteServiceModal,
  DeleteStaffAccountConfirmationModal,
  DisableCategoryModal,
  DisableServiceConfirmationModal,
  DuplicateCategoryModal,
  EditCategoryModal,
  EditMenuModal,
  EditSharedGroupModal,
  EditStaffAccountModal,
  EmailModal,
  EnableClassConfirmationModal,
  HiddenGroupModal,
  SkuCancelConfirmModal,
  SkuAvailabilityModal,
  SkuMissedPickupModal,
  SkuOutOfStockConfirmModal,
  EnableFreeClassModal,
  EnableServicePricingModal,
  IcalExportModal,
  ImageCarousel,
  IntegrationRequestModal,
  ItemAvailabilityModal,
  ItemInReviewModal,
  ItemSubmitErrorModal,
  SkuItemInReviewModal,
  SkuRemoveItemFromCategoryModal,
  ManageSmartSpotModal,
  MarkClassAsFullConfirmationModal,
  MarkClassAsNotFullConfirmationModal,
  MFARecoveryCodesModal,
  MFASetupModal,
  MissingDataFeedbackModal,
  NetworkCapRecurrenceModal,
  NoEquipmentOrPractitionerModal,
  NotListedPlatformModal,
  PayoutAgreementDialog,
  PlatformNotSupportedModal,
  PremiumOnlyModal,
  PriceSubmitErrorModal,
  PublishScheduleDraftModal,
  SkuVenueClosedConfirmationModal,
  SmartSpotONConfirmModal,
  SmartRateHowItWorksModal,
  PublishSuccessModal,
  RemoveStudioResponseConfirmationModal,
  ReportReviewConfirmationModal,
  ReservationCancellationModal,
  ReservationFeedbackModalV2,
  ResetCalendarSyncFlowModal,
  ResetScheduleIncrementsModal,
  ReviewMenuItemsModal,
  ScheduleConflictsModal,
  ServiceInReviewModal,
  SuccessDisabledTimeWindowModal,
  TurnOnSmartSpotConfirmationModal,
  UpdateIncrementsConfirmationModal,
  VenueClosedConfirmationModal,
};

export default MODAL_MAP;
